"use client";
import * as ReactDOM from "react-dom";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../styles/modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDiamond } from "@fortawesome/free-solid-svg-icons";
import Image from "next/image";

export default function GalleryModal({
  backgroundColor,
  showModal,
  setShowModal,
  roomData,
}) {
  if (!showModal || !roomData) return null;

  const {
    roomName,
    roomDesc,
    roomImages,
    roomAmenities, // ✅ NEW
  } = roomData;

  const hasCategory = roomAmenities?.some((a) => a.category);

  const groupAmenitiesByCategory = (amenities = []) =>
    amenities.reduce((acc, item) => {
      if (!item.category) return acc;
      acc[item.category] = acc[item.category] || [];
      acc[item.category].push(item);
      return acc;
    }, {});

  return (
    typeof window !== "undefined" &&
    ReactDOM.createPortal(
      <div
        className="modal fade show"
        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-lg room-modal">
          <div className="modal-content">
            <div className="modal-body p-0 position-relative">
              <h5 className="modal-title p-3">{roomName}</h5>

              <button
                type="button"
                className="btn-close"
                style={{ background: backgroundColor }}
                onClick={() => setShowModal(false)}
              >
                X
              </button>

              {/* Images Slider */}
              <Swiper
                modules={[Navigation, Pagination]}
                navigation
                loop
                className="images-slider"
              >
                {roomImages?.map((img, idx) => (
                  <SwiperSlide key={idx}>
                    <img
                      src={img.roomImage}
                      alt={`Room Image ${idx + 1}`}
                      className="img-fluid img-thumb"
                      loading="lazy"
                      decoding="async"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>

              <div className="bottom-modal-content p-4">
                {/* Description */}
                <div className="property-description mt-3">
                  <p>{roomDesc?.replace(/<[^>]+>/g, "")}</p>
                </div>

                {/* ✅ CATEGORY-WISE AMENITIES */}
                {/* ✅ CATEGORY-WISE AMENITIES */}
                <div className="property-amenitiess mt-4">
                  <h6 className="mb-3 !text-[13px] fw-semibold">
                    Room Amenities
                  </h6>

                  {roomAmenities?.length > 0 ? (
                    <div className="row">
                      {/* 🔵 STAAH → CATEGORY WISE */}
                      {hasCategory &&
                        Object.entries(
                          groupAmenitiesByCategory(roomAmenities),
                        ).map(([category, amenities], idx) => (
                          <div
                            key={idx}
                            className="col-lg-4 col-md-6 col-sm-12 mb-4"
                          >
                            <h6
                              className="fw-semibold mb-2"
                              style={{ fontSize: "13px", color: "black" }}
                            >
                              {category}
                            </h6>

                            {amenities.map((amenity, i) => (
                              <p
                                key={i}
                                className="mb-2 d-flex align-items-center !text-[12px]"
                              >
                                <Image
                                  src={amenity.icon}
                                  alt={amenity.name}
                                  width={14}
                                  height={14}
                                  className="me-2"
                                />
                                {amenity.name}
                                {/* <FontAwesomeIcon className="me-2" icon={faDiamond} size="xs" color="grey"></FontAwesomeIcon>{" "}{amenity.name} */}
                              </p>
                            ))}
                          </div>
                        ))}

                      {/* 🟠 CMS → FLAT */}
                      {!hasCategory &&
                        roomAmenities?.map((amenity, idx) => (
                          <div
                            key={idx}
                            className="col-lg-4 col-md-6 col-sm-12 mb-2"
                          >
                            <p className="mb-2 d-flex align-items-center !text-[12px]">
                              <Image
                                src={amenity.icon}
                                alt={amenity.name}
                                width={14}
                                height={14}
                                className="me-2"
                              />
                              {/* <FontAwesomeIcon className="me-2" icon={faDiamond} size="xs" color="grey"></FontAwesomeIcon>{" "}{amenity.name} */}
                              {amenity.name}
                            </p>
                          </div>
                        ))}
                    </div>
                  ) : (
                    <p className="text-muted !text-[12px] mb-0">
                      No amenities available.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>,
      document.body,
    )
  );
}
